import React, { useContext, useState, useEffect, useRef } from 'react'
import { Button, TextField, makeStyles } from '@material-ui/core'
import TranslationLabel from '../../../../core/components/TranslationLabel'
import { BasketContext } from '../../context/BasketContext'
import { CoreContext } from '../../../../core/context/CoreContext'
import TagIcon from '@material-ui/icons/LocalOfferOutlined'
import priceDtoHelper from '../../../../shared/PriceDtoHelper'

const useStyles = makeStyles((theme) => ({
  listPrices: {
    borderRight: '1px solid',
    borderRightColor: theme.palette.grey[200],
    minWidth: 200,
    padding: '7px 0 9px 50px',
    position: 'relative',
  },
  prices: {
    position: 'relative',
    padding: '10px 0 7px 10px',
    textAlign: 'center',
  },
  tag: {
    position: 'absolute',
    top: 17,
    left: 10,
    fontSize: 28,
    color: theme.palette.grey[400],
    transform: 'rotate(90deg)',
  },
  priceNormal: {
    fontSize: 12,
    color: theme.palette.grey[500],
    minWidth: '50px',
    textAlign: 'center',
    display: 'inline-block',
  },
  priceText: {
    fontSize: 12,
    color: theme.palette.grey[500],
    display: 'inline-block',
    marginLeft: 10,
  },
  currency: {
    position: 'absolute',
    top: '-16px',
    left: '62px',
    color: theme.palette.grey[600],
    fontSize: 12,
  },
  priceYours: {
    fontSize: 16,
    fontWeight: 'bold',
    minWidth: '50px',
    textAlign: 'right',
    display: 'inline-block',
  },
  cta: {
    display: 'flex',
    margin: '10px 10px 0',
    flexWrap: 'wrap',

    [theme.breakpoints.up('md')]: {
      minWidth: 190,
    },
  },
  quantity: {
    'width': 60,
    'textAlign': 'center',
    'marginRight': 5,
    'marginBottom': 10,

    '& input': {
      paddingRight: 0,
    },
  },
  btn: {
    'width': 'auto',
    'color': 'white',
    'backgroundColor': 'black',
    'flexGrow': 1,
    'height': 40,
    'marginBottom': 10,

    '&:hover': {
      backgroundColor: theme.palette.grey[800],
    },
  }
}))

export default function AddProductButton(props) {
  const classes = useStyles()
  const { product, type, showRetailPrice } = props
  const { colli } = product
  const core = useContext(CoreContext)
  const basket = useContext(BasketContext)
  const [currentPrice, setCurrentPrice] = useState(priceDtoHelper.findPrice(product.colli, product))
  const [quantity, setQuantity] = useState(product.colli)
  const inputRef = useRef(null)

  useEffect(() => {
    if (quantity === '') {
      return
    }

    if (quantity <= 0) {
      handleChangeQuantity({
        target: {
          value:
            (product.priceDtos[0] && product.priceDtos[0].minQuantity) || 1,
        },
      })
    }
  }, [quantity])


  const handleChangeQuantity = (e) => {
    let val = e.target.value
    let price = priceDtoHelper.findPrice(val, product)

    setQuantity(val)
    setCurrentPrice(price)

    if (props.setQuantity) {
      props.setQuantity(val)
    }
    if (props.setCurrentPrice) {
      props.setCurrentPrice(price)
    }
  }

  const addToBasket = (e) => {
    basket.add({
      itemId: product.productNo,
      qty: priceDtoHelper.findNextAllowedNumber(product, quantity),
      campaignId: null,
      requestedShippingDate: null,
    })
  }

  const onBlurHandler = () => {
    const allowedQuantity = priceDtoHelper.findNextAllowedNumber(product, quantity)
    setQuantity(allowedQuantity)
    setCurrentPrice(priceDtoHelper.findPrice(allowedQuantity, product))
  }

  return (
    <>
      <div
        className={type === 'list' ? classes.listPrices : classes.prices}
        style={{ minWidth: showRetailPrice ? '150px' : '' }}>
        {/* Add currency at the top of table */}
        {props.showCurrencyOnTop ? (
          <div className={classes.currency}>
            {core.user.selectedCustomer.currency}
          </div>
        ) : null}

        {/* Normal price */}
        {!showRetailPrice && (
          <>
            {priceDtoHelper.renderPrice(currentPrice, classes)}
            {priceDtoHelper.renderYourPrice(currentPrice, quantity, classes)}
          </>
        )}

        {/* Retail Price */}
        {showRetailPrice && (
          <>
            <TagIcon className={`${classes.tag} ${classes.listTag}`} />
            <div style={{ marginTop: 12 }}>
              <span className={classes.priceYours}>
                {product.recommendedRetailPrice}
              </span>
              <span className={classes.priceText}>
                <TranslationLabel name='price' />
              </span>
            </div>
          </>
        )}
      </div>

      {/* Quantity & buy btn */}
      <div className={classes.cta}>
        <TextField
          onBlur={onBlurHandler}
          size='small'
          type='number'
          value={quantity}
          onChange={handleChangeQuantity}
          className={classes.quantity}
          InputProps={{
            inputProps: {
              step: colli || 1,
            },
          }}
          inputRef={inputRef}
          onClick={() => {
            inputRef.current.select(0, -1)
          }}
          label={<TranslationLabel name='numberOf' />}
          variant='outlined'
        />
        <Button
          disabled={priceDtoHelper.hasNoPrice(product)}
          variant='contained'
          disableElevation
          className={classes.btn}
          onClick={addToBasket}>
          <TranslationLabel name='addToCart' />
        </Button>
      </div>
    </>
  )
}
